"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GlobalStyles;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@emotion/react");
function isEmpty(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}

// TODO: Replace when Material UI 5.0 releases
// https://next.material-ui.com/api/global-styles/

function GlobalStyles(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/_react.default.createElement(_react2.Global, {
    styles: globalStyles
  });
}
GlobalStyles.propTypes = {
  defaultTheme: _propTypes.default.object,
  styles: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func])
};